"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePasswordReset = void 0;
const react_1 = require("react");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
const usePasswordReset = (options) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [codeSent, setCodeSent] = (0, react_1.useState)(false);
    const [resetComplete, setResetComplete] = (0, react_1.useState)(false);
    const handleSuccess = (0, react_1.useCallback)(() => {
        setError(null);
        if (options?.onSuccess) {
            options.onSuccess();
        }
    }, [options]);
    const handleError = (0, react_1.useCallback)((err) => {
        setError(err);
        if (options?.onError) {
            options.onError(err);
        }
    }, [options]);
    const initiateReset = (0, react_1.useCallback)(async (username) => {
        setIsLoading(true);
        setError(null);
        try {
            await amplifyBootstrap_1.Auth.forgotPassword(username);
            setCodeSent(true);
            handleSuccess();
        }
        catch (err) {
            const error = err instanceof Error ? err : new Error(String(err));
            handleError(error);
            throw error;
        }
        finally {
            setIsLoading(false);
        }
    }, [handleSuccess, handleError]);
    const confirmReset = (0, react_1.useCallback)(async (username, code, newPassword) => {
        setIsLoading(true);
        setError(null);
        try {
            await amplifyBootstrap_1.Auth.forgotPasswordSubmit(username, code, newPassword);
            setResetComplete(true);
            handleSuccess();
        }
        catch (err) {
            const error = err instanceof Error ? err : new Error(String(err));
            handleError(error);
            throw error;
        }
        finally {
            setIsLoading(false);
        }
    }, [handleSuccess, handleError]);
    return {
        initiateReset,
        confirmReset,
        isLoading,
        error,
        codeSent,
        resetComplete,
    };
};
exports.usePasswordReset = usePasswordReset;
